import { env } from '../constants';

const isDomesticServer = url => new RegExp(`^${env.URL_API}`).test(url);

export default isDomesticServer;
